import * as Yup from 'yup';
import { useState } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { Box, Stack, Typography } from '@mui/material';
import { Encryption } from 'src/functions/function';
import { api } from 'src/Api';
import BackButton from 'src/components/BackButton';
import InputField from 'src/components/InputField';
import LoadingButtonWrapper from 'src/components/LoadingButtonWrapper';
import { toast } from 'react-toastify';
import Iconify from 'src/components/Iconify';
import palette from 'src/theme/palette';

export default function RegisterForm() {
  const [loading, setloading] = useState(false);
  const [success, setSuccess] = useState(false);

  const RegisterSchema = Yup.object().shape({
    email: Yup.string().email('Email must be a valid email address').required('Email is required')
  });

  const formik = useFormik({
    initialValues: {
      email: ''
    },
    validationSchema: RegisterSchema,
    onSubmit: () => {
      sendLink();
    }
  });

  const { errors, values, touched, handleSubmit, getFieldProps } = formik;

  function sendLink() {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify({
        email: Encryption(values.email, process.env.REACT_APP_SECRET_KEY)
      }),
      redirect: 'follow'
    };

    setloading(true);

    fetch(api.send_forgot_password, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setSuccess(true);
        } else {
          setloading(false);
          toast.error(result.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => {
        setloading(false);
      });
  }

  return (
    <Stack
      sx={{
        backgroundColor: '#fff',
        borderRadius: '15px',
        paddingX: 5,
        paddingTop: 3,
        paddingBottom: 6,
        boxShadow: palette.primary.mainShadow,
        border: `1.5px solid ${process.env.REACT_APP_PRIMARY}`,
        marginBottom: 7
      }}
    >
      <BackButton />
      {success ? (
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Box
            style={{
              backgroundColor: '#A7F3D0',
              height: 80,
              width: 80,
              borderRadius: 100,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: 10
            }}
          >
            <Iconify icon={'game-icons:check-mark'} style={{ color: '#064E3B', fontSize: 35 }} />
          </Box>
          <Typography
            sx={{ color: palette.primary.titledark, fontSize: 14, fontFamily: 'poppinsMedium' }}
          >
            We sent an email to recover a password
          </Typography>
        </Box>
      ) : (
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Stack spacing={0}>
              <InputField
                name="email"
                label="Email"
                type="email"
                placeholder="you@example.com"
                autoComplete="username"
                {...getFieldProps('email')}
                error={touched.email && errors.email}
                helperText={touched.email && errors.email}
                labelFontMedium
                fontFamily={'poppinsRegular'}
              />

              <LoadingButtonWrapper
                type="submit"
                loading={loading}
                title="Request new password"
                style={{ marginTop: 20 }}
              />
            </Stack>
          </Form>
        </FormikProvider>
      )}
    </Stack>
  );
}
